<cc-progress-bar [isLoading]="isLoading$ | async"></cc-progress-bar>
@if (data$ | async; as data) {
  <div class="flex w-full h-full">
    <dx-pie-chart
      id="pie"
      class="w-full h-full"
      palette="Ocean"
      [dataSource]="data"
    >
      <dxo-legend
        [visible]="true"
        orientation="horizontal"
        horizontalAlignment="center"
        verticalAlignment="bottom"
        itemTextPosition="right"
        [columnCount]="2"
        [margin]="0"
      ></dxo-legend>
      <dxo-common-series-settings>
        <dxo-label [visible]="false"></dxo-label>
      </dxo-common-series-settings>
      <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltip">
      </dxo-tooltip>
      <dxi-series argumentField="key" valueField="value"></dxi-series>
    </dx-pie-chart>
  </div>
}
